import React, { useState, useEffect } from 'react';
import UserStatsBadges from './UserStatsBadges';
import MonthlyStatsBadges from './MonthlyStatsBadges';
import HorizontalMonthlyStats from './HorizontalMonthlyStats';

const ReadingStatsResults = ({username}) => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Definimos los meses esperados
  const expectedMonths = ['2025_01', '2025_02', '2025_03', '2025_04', '2025_05'];
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Reemplaza con tu URL real
        const response = await fetch('https://img-dinoblanco-shs.s3.us-east-1.amazonaws.com/c/r/res_data_shs.json');
        
        if (!response.ok) {
          throw new Error('Error al cargar los datos');
        }
        
        const data = await response.json();
        setUserData(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Función para obtener datos con valores por defecto si faltan
  const getStatsWithDefaults = (monthsData) => {
    return expectedMonths.map(month => {
      if (monthsData && monthsData[month]) {
        return {
          month,
          ...monthsData[month]
        };
      }
      
      // Valores por defecto para meses sin datos
      return {
        month,
        cl: 0,
        ld: 0,
        hl: 0,
        dl: 0
      };
    });
  };

  if (loading) {
    return (
      <div className="mx-auto my-4 max-w-4xl">
        <div className="bg-gradient-to-r from-purple-400 to-blue-500 p-4 rounded-md text-white text-center shadow-md">
          Cargando tus estadísticas de lectura...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mx-auto my-4 max-w-4xl">
        <div className="bg-red-500 p-4 rounded-md text-white text-center shadow-md">
          Error: {error}
        </div>
      </div>
    );
  }

  if (!userData || Object.keys(userData).length === 0) {
    return (
      <div className="mx-auto my-4 max-w-4xl">
        <div className="bg-yellow-500 p-4 rounded-md text-white text-center shadow-md">
          No se encontraron datos de lectura para mostrar
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto my-4 max-w-4xl">
      {/* Mostrar estadísticas para cada usuario */}
      {Object.entries(userData).map(([userId, monthsData]) => {
        //console.log(monthsData)
        // Obtener datos con meses faltantes completados
        const userStats = getStatsWithDefaults(monthsData);

        return username === userId?
        <HorizontalMonthlyStats userData={monthsData} /> : <></>
      })}
    </div>
  );
};

export default ReadingStatsResults;